import { render } from "./SeDropdownItem.vue?vue&type=template&id=320ff666&scoped=true&ts=true"
import script from "./SeDropdownItem.vue?vue&type=script&lang=ts"
export * from "./SeDropdownItem.vue?vue&type=script&lang=ts"

import "./SeDropdownItem.vue?vue&type=style&index=0&id=320ff666&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320ff666"]])

export default __exports__